module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"enterQuestion":"Введите вопрос","requiredField":"Обязательное поле для заполнения"}}')
  delete Component.options._Ctor
}
